"use client";

import { Sidetab } from "@typeform/embed-react";
import { useAtom, useAtomValue } from "jotai";
import { type FunctionComponent, memo, useEffect, useState } from "react";

import { useResponsive } from "shared/hooks";
import { accountAtom } from "shared/lib/account";
import { theme } from "shared/lib/styles";

import { safeSetLocalStorage } from "scmp-app/scmp-sdk";

import { typeformAtom } from "./atoms";
import { HomepageHKTypeformIsShownKey, TypeformId } from "./const";

export const TypeformComponent: FunctionComponent = () => {
  const [{ isShow }, setTypeformState] = useAtom(typeformAtom);

  const { user } = useAtomValue(accountAtom);
  const isMobile = useResponsive(theme.breakpoints.only("mobile"), false);

  const [isShowSidetabButton, setIsShowSidetabButton] = useState(false);

  useEffect(() => {
    if (!isShow || localStorage?.getItem(HomepageHKTypeformIsShownKey) === "1") return;

    setIsShowSidetabButton(true);
  }, [isShow, setIsShowSidetabButton]);

  const handleClick = () => {
    safeSetLocalStorage(HomepageHKTypeformIsShownKey, "1");
  };

  const hiddenFields = {
    utm_medium: isMobile ? "mdot" : "desk",
    utm_term: user?.uuid ?? "",
  };

  const handleSurveyFinished = () => {
    setTypeformState({ isShow: false });
  };

  if (!isShowSidetabButton || !isShow) return null;
  return (
    <Sidetab
      buttonColor="#FFCA05"
      buttonText="Give feedback"
      hidden={hiddenFields}
      hideHeaders
      id={TypeformId}
      medium="sidetab"
      onClose={handleSurveyFinished}
      onReady={handleClick}
      onSubmit={handleSurveyFinished}
    />
  );
};

export const Typeform = memo(TypeformComponent);
